
import { FormFieldWrapper } from '@/components/ui/form-field-wrapper';
import { MoneyInput } from '@/components/ui/money-input';
import { formPlaceholders } from '@/data/formPlaceholders';

interface TransactionAmountFieldProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
}

export const TransactionAmountField = ({ value, onChange, error, disabled }: TransactionAmountFieldProps) => {
  return (
    <FormFieldWrapper 
      label="Valor" 
      required={true}
      error={error}
    >
      <MoneyInput
        id="amount"
        value={value}
        onChange={onChange}
        placeholder={formPlaceholders.amount}
        disabled={disabled}
        required
      />
    </FormFieldWrapper>
  );
};
